<template>
  <div class="form-group row mt-5 d-print-none">
    <div
      v-if="hasPreviousStep"
      class=""
      :class="{
        'col-6 text-right': hasNextStep,
        'col-12 text-center': !hasNextStep,
      }"
    >
      <a
        href="#"
        type="button"
        class="btn btn-primary btn-hend btn-large"
        title="Previous"
        @click.prevent="onPreviousClick"
      >
        Previous
      </a>
    </div>
    <div
      v-if="hasNextStep"
      class="col-6"
      :class="{
        '': hasPreviousStep,
        'col-12 text-center': !hasPreviousStep,
      }"
    >
      <a
        href="#"
        type="button"
        class="btn btn-primary btn-hend btn-large"
        :title="nextStepLabel"
        @click.prevent="onNextClick"
      >
        {{ nextStepLabel }}
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters, mutation } from '../store';
export default {
  name: 'Stepper',

  computed: {
    ...mapGetters(['hasNextStep', 'hasPreviousStep', 'currentStep']),

    /** @returns {string} */
    nextStepLabel() {
      return this.currentStep.nextStepLabel || 'Next';
    },
  },

  methods: {
    onPreviousClick() {
      this.$store.commit(mutation('SET_PREVIOUS_STEP'));
    },
    onNextClick() {
      this.$store.commit(mutation('SET_NEXT_STEP'));
    },
  },
};
</script>
